import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ButtonV2 from '../../../common/components/atom/ButtonV2/Button'
import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import MomiList from '../components/MomiList/MomiList'
import AddMomiDialog from '../components/AddMomiDialog/AddMomiDialog'
import ImportMomiCsvDialog from '../components/ImportMomiCsvDialog/ImportMomiCsvDialog'
import { buildCsvTemplate, downloadCsv } from '../../../common/utils/csv'

export default function MomiPage() {
  const [addDialogOpen, setAddDialogOpen] = useState(false)
  const [importDialogOpen, setImportDialogOpen] = useState(false)
  const navigate = useNavigate()

  const handleDownloadTemplate = () => {
    const csv = buildCsvTemplate(
      ['momi_uuid', 'momi_name'],
      [['00000000-0000-0000-0000-000000000000', 'MoMi exemple']],
    )
    downloadCsv('momi_template.csv', csv)
  }

  return (
    <div>
      <HeaderTitleContent>Mes MoMis</HeaderTitleContent>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '1.5rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
        <ButtonV2
          onClick={() => navigate('/main/setting')}
          variant="outlined"
          size="medium"
          color="secondary"
        >
          ← Retour
        </ButtonV2>
        <ButtonV2
          onClick={() => setAddDialogOpen(true)}
          variant="dashboard-btn-outlined"
          size="medium"
          color="secondary"
        >
          Ajouter MoMi
        </ButtonV2>
        <ButtonV2
          onClick={() => setImportDialogOpen(true)}
          variant="dashboard-btn-outlined"
          size="medium"
          color="secondary"
        >
          Importer CSV
        </ButtonV2>
        <ButtonV2
          onClick={handleDownloadTemplate}
          variant="outlined"
          size="medium"
          color="secondary"
        >
          Télécharger le modèle
        </ButtonV2>
      </div>
      <MomiList />
      <AddMomiDialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)} />
      <ImportMomiCsvDialog open={importDialogOpen} onClose={() => setImportDialogOpen(false)} />
    </div>
  )
}
